let Vue = require('vue');

Vue.directive('batch-selection', {
    twoWay: true,
    priority: 1000,

    params: ['page', 'pickers'],

    bind: function () {
        let self = this;
    },
    update: function (value) {
        let self = this;
    },
    unbind: function () {
        let self = this;
        //$(this.el).off().select2('destroy')
    }
});



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/batch-selection.js